import { QualificationStatus } from 'common/types';
export const userCenterImageList = ['jpg', 'jpeg', 'png', 'JPG', 'JPEG', 'PNG'];
export const DEFAULT_REGION = '86';
export const DEFAULT_SHORT = 'CN';

export enum UserCertifyType {
  UnCertified, // 0未认证
  PersonalCertified, // 1个人认证
  EnterpriseCertified, // 2企业认证
}

export const UserCertifyTypeToText = {
  [UserCertifyType.UnCertified]: '未认证', // 0未认证
  [UserCertifyType.PersonalCertified]: '个人认证', // 1个人认证
  [UserCertifyType.EnterpriseCertified]: '企业认证', // 2企业认证
};

export enum UserQualificationStatus {
  Unverified = 0, //未认证
  Waiting = 1, //等待审核
  Failed = 2, // 审核不通过
  Verified = 3, //审核通过
}

export enum UserRoleType {
  Allocator = 'ALLOCATOR',
  External = 'EXTERNAL_CONTACTS',
}

export const UserRoleMap = {
  [UserRoleType.External]: {
    label: '制作方',
    value: 'ALLOCATOR',
  },
  [UserRoleType.Allocator]: {
    label: '需求方',
    value: 'EXTERNAL_CONTACTS',
  },
};

export const ArtistQualificationStatusMap = {
  [QualificationStatus.Unverified]: {
    label: '未认证',
    color: '',
  },
  [QualificationStatus.Waiting]: {
    label: '申请中',
    color: 'processing',
  },
  [QualificationStatus.Failed]: {
    label: '未通过',
    color: 'error',
  },
  [QualificationStatus.Verified]: {
    label: '已通过',
    color: 'success',
  },
};

export const UserDefaultAvatar =
  'https://static.fuxi.netease.com/fuxi-art-platform/theme-dark-light/tiangong-user-avatar/default-avatar.webp';
export const UserDefaultAvatarNiming =
  'https://static.fuxi.netease.com/fuxi-art-platform/theme-dark-light/tiangong-user-avatar/default-avatar-niming.webp';
